import { css } from '@emotion/react';
import { IonSkeletonText } from '@ionic/react';
import React from 'react';

interface SkeletonTextProps {
  height?: string | number;
  width?: string | number;
  margin?: string | number;
}

export const SkeletonText: React.FC<SkeletonTextProps> = ({ height = '100%', width = '100%', margin = 'auto' }) => {
  return <IonSkeletonText animated css={css({ height, width, margin })} />;
};
